import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { NavBarComponent } from './core/components/navbar/navbar.component';
import { LoadingModalComponent } from '@shared/components/loading-modal/loading-modal.component';
import { CommonModule } from '@angular/common';
import { SignalsService } from '@shared/services/signals/signals.service';
import { ToastModule } from 'primeng/toast';
import { AppService } from './app.service';
import { MainComponent } from '@core/components/main/main.component';
import { AdminService } from './features/admin/admin.service';
import { AuthService } from '@shared/services/auth.service';

@Component({
    selector: 'app-root',
    imports: [
        CommonModule,
        MainComponent,
        NavBarComponent,
        LoadingModalComponent,
        ToastModule,
    ],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class AppComponent implements OnInit {

  //inject AuthService to ensure it is instantiated at app startup
  authService = inject(AuthService);
  signalService = inject(SignalsService);
  appService = inject(AppService);
  adminService = inject(AdminService);

  

  ngOnInit(): void {
    //Init mobile app watcher
    this.appService.initMobileAppWatcher();



    if (localStorage.getItem('emulatedPilot') &&
      !this.signalService.isEumulatingEmpNumActive$()) {
      console.log('%cEmulated Pilot data found...removing pilot data', 'color: orange');
      this.adminService.resetEmulatedPilot();
    }
  }

}
